import {  useEffect, useState } from "react";
import LoadingAnimation from "../../components/LoadingAnimation";
import { useSelector } from "react-redux";
import DarkWrapper from "./DarkWrapper";



let showLoadingInfo = false;
showLoadingInfo =
  showLoadingInfo && process.env.REACT_APP_ENV === "development";

const LoadingView = ({ showAnimationAfterMS = 1000 }) => {
  const loadingState = useSelector((state) => state.loadingState);
  const [showAnimation, setShowAnimation] = useState(false);

  const successState = useSelector((state) => state.successState);
  const successShowing = successState.showSuccessBucket.length > 0;

  //useDisableBackground({env: "loadingView"});



  useEffect(() => {
    let brojac = 0;
    const loadingInterval = setInterval(() => {
      brojac = brojac + 100;

      if (brojac > showAnimationAfterMS) {
        setShowAnimation(true);
        clearInterval(loadingInterval);
      }
    }, 100);

    return () => {
      clearInterval(loadingInterval);
    };
  }, []);

  const styles = {
    innerElement: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: `rgba(0,0,0,0.85)`,
      minWidth: "120px",
      minHeight: "120px",
      borderRadius: "0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      borderRadius: "10px",
      padding: "40px",
    },
  };

  return (
    <DarkWrapper isTransparent = {successShowing} env = "loadingView">
      {successShowing === false && showAnimation === true && (
        <div className="fade-in" style={styles.innerElement}>
          <LoadingAnimation />
          {showLoadingInfo && (
            <div
              style={{
                color: "white",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div>{loadingState.loadingBucket.length}</div>
              {loadingState.loadingBucket.map((element) => {
                return <div key={element.id}>{element.path}</div>;
              })}
            </div>
          )}
        </div>
      )}
    </DarkWrapper>
  );
};

export default LoadingView;
